module.exports = __webpack_public_path__ + "img/megaways.ef142d30.svg";